<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapname1_t">Contents</h1>
<h2 class="toc_chap1"><a href="#/xhtml/06_list">List of Illustrations</a></h2>
<h2 class="toc_chap1"><a href="#/xhtml/06_preface">Preface</a></h2>
<h2 class="toc_chap"><a href="#/xhtml/07_Chapter_1"><span class="tocn">Chapter 1</span> Victory at Waterloo</a></h2>
<h2 class="toc_chap"><span href="#/xhtml/08_Chapter_2" title="Link target outside of Sample"><span class="tocn">Chapter 2</span> Europe Against Napoleon</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/09_Chapter_3" title="Link target outside of Sample"><span class="tocn">Chapter 3</span> The Military Balance</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/10_Chapter_4" title="Link target outside of Sample"><span class="tocn">Chapter 4</span> The Campaign of 1814</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/11_Chapter_5" title="Link target outside of Sample"><span class="tocn">Chapter 5</span> The Bourbon Restoration</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/12_Chapter_6" title="Link target outside of Sample"><span class="tocn">Chapter 6</span> The Hundred Days</span></h2>
<h2 class="toc_chap2"><span href="#/xhtml/notes" title="Link target outside of Sample">Notes</span></h2>
<h2 class="toc_chap1"><span href="#/xhtml/bibliography" title="Link target outside of Sample">Select Bibliography</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?1476081e